import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-lessonplan',
  templateUrl: './lessonplan.component.html',
  styleUrls: ['./lessonplan.component.scss'],
   providers:[MasterService]
})
export class LessonplanComponent implements OnInit {

  memberdetails:any[]=[];
        classdetails:any[]=[];
        arrashead:any=[];
        arrastype:any=[];
        closeResult: string;
        classes: any=[];
        section: any=[];
        arrcourse:any=[];
        arrsubcomb:any=[];
        student:boolean=true;
        staff:boolean=false;
        memberdash:any={};
        objass:any={};
        objastype:any={};
        objfilt:any={};
        arreval:any=[];
        arrevpatern:any=[];
        arrcat:any=[];
        arract:any=[{name:'Yes'},{name:'No'}];
        arrledom:any=[{name:'Weekly'},{name:'Monthly'},{name:'Quarterly'},{name:'Half Yearly'},{name:'Yearly'}];
        objmethod:any={};
        objpo:any={};
        objlevel:any={};
        objco:any={};
        selstudent:any={};
        modalOptions:NgbModalOptions;
        private modalRef: NgbModalRef;
  arrsubjects: any;
  arflstudent: any;
      
        constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }
      
        open(content) {
          this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });
        }
      
        private getDismissReason(reason: any): string {
          if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
          } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
          } else {
            return `with: ${reason}`;
          }
        }
      
      
      
        ngOnInit(): void {
          
          this.getcourses();
  
          // this.getobemlevels();
          // this.getobempo();
          // this.getobemtmethod();
        }
      
      
       masclass() {
      this.mservice.classmasterrolewise(0,this.objfilt.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.objfilt.clid=resultArray[0].clid;
              this.subjects(this.objfilt.clid,this.objfilt.crid);

              // this.fmodel1.clid=resultArray[0].clid;
              // this.cmodel.clid=resultArray[0].clid;
              // this.massection();
              // this.masperiod();
             // this.mascourse();
             
          },
          error => console.log("Error :: " + error)
          )
    }
       subjects(clid,crid) {
        this.mservice.subjectsrolewise(0,0,clid,'asaa',crid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrsubjects = resultArray;
                // this.corsubjects = resultArray;
                this.objfilt.suid=resultArray[0].suid;
               // this.cmodel.suid=resultArray[0].suid;
                this.getobetlp();
            },
            error => console.log("Error :: " + error)
            )
      }
        private getcourses() {
      
          this.mservice.getcourse()
        .subscribe((result:any) => {
        
        this.arrcourse=result;
        this.objfilt.crid=result[0].crid;
        this.masclass();
        
        }, error => {
        
        //alert('error in r');
        // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
        }
        );
          
          
        }
      
        // Getsubcomb()
        // {
        //   debugger
        //   this.mservice.sel_sp_exmsubcomb()
        //   .subscribe(
            
        //    resultArray =>{
        //     console.log('result',resultArray) ;
        //     this.objfilt.sucbid=resultArray[0].sucbid;
        //     //this.clsdate=resultArray;
        //     this.arrsubcomb = resultArray;
        //     //this.getevpattern();
        //     },
        //    error => console.log("Error :: " + error)
        // )
        // }
         
      
      
        // massection() {
        //   this.mservice.massection()
        //       .subscribe(
        //       resultArray => {
        //           console.log('getdashcounts', resultArray);
        //           this.section = resultArray;
                 
        //       },
        //       error => console.log("Error :: " + error)
        //       )
        // }
    
           
    
        
    
        
  
         getobemtpmap(obj) {
          this.mservice.getobemtpmap(obj)
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arreval = resultArray;
                 
              },
              error => console.log("Error :: " + error)
              )
        }
    
        getobetlp() {
      
          
          this.mservice.getobetlp(this.objfilt)
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arrastype=resultArray;
                 this.getobemtpmap(this.objfilt);
                 
              },
              error => console.log("Error :: " + error)
              )
        }
      
       
        
       
          onmemberselectEvent(item) {

    console.log('item',item);
    this.objlevel.duration=item.duration;
    this.objlevel.tpid=item.tpid;
   }
        onmemberChangeSearch(sertxt) {
    debugger
  

  

  this.arflstudent= this.arreval.filter(item => {
      
      const nameMatches = item.tpnm.toLowerCase().includes(sertxt.toLowerCase());
     
      return nameMatches ; 
    });
    console.log('arflstudent',this.arflstudent);
  }
 
       
    
        
       
        
      
     
    
    
    
    
    
       openlevels(content,objdata,cmd) {
          debugger
         
          
          if(cmd=='insert')
          {
            this.objlevel={};
           
            
            
            this.objlevel.lpid='0';
            this.objlevel.tpnm='';
            this.objlevel.duration=0;
            this.objlevel.pltype='Monthly';
            
            this.objlevel.frdt=this.mservice.getdatetoday();
            this.objlevel.todt=this.mservice.getdatetoday();
             this.objlevel.active='Yes';
           
            this.objlevel.oprtype='insert';
            this.objlevel.clid=this.objfilt.clid;
            this.objlevel.crid=this.objfilt.crid;
            this.objlevel.suid=this.objfilt.suid;
           
          }
        
          else if(cmd=='update')
          {
            this.objlevel=objdata;
            // this.getobemtpmap(this.objfilt);
            this.objlevel.oprtype='update';
this.onmemberChangeSearch(objdata.tpnm);
          this.selstudent=  this.arflstudent[0];
          }
          
          this.modalOptions = {
            backdrop:'static',
            backdropClass:'customBackdrop',
            size:'lg'
           
          }
          this.modalRef=this.modalService.open(content,this.modalOptions);
          
          this.modalRef.result.then((result) => {
         
               
            }, (reason) => {
                
            });
        }
    
    
        save_obemlevels()
      {
        // this.objlevel.tpid=this.selstudent.tpid;
        if(this.objlevel.tpid)
        {
      console.log('saveobj',this.objlevel);
        this.mservice.save_obetlp(this.objlevel)
            .subscribe(
            result => {
                console.log('SavegenmasDetails', result);
                //this.suppliers = resultArray;
                alert(result.message);
                if(result.status=='success')
                {
                  let localmodref=this.modalRef;
                  localmodref.close();
                //  this.masasstype();
               this.getobetlp();
                }
               else
               {
      
               }
            },
            error =>{ alert('Error While saving...');}
            )
          }

          else
          {
            alert('Please select topic');
          }
      }
      }
      
    
  
